import classnames from 'classnames';
import React, { forwardRef } from 'react';
import usePriceDrop from '~/hooks/usePriceDrop';

type OwnProps = React.SVGProps<SVGSVGElement>;

const NewPriceIconLarge = forwardRef<SVGSVGElement, OwnProps>((props, ref) => {
  const { restrictedState } = usePriceDrop();

  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
      className={classnames(props.className, { '-rotate-45': restrictedState })}
    >
      <g id="PriceDrop Icon" clipPath="url(#clip0_7970_4223)">
        <circle
          id="Container"
          cx="30.779"
          cy="30.779"
          r="30.779"
          fill="#2F9E44"
        />
        <path
          id="Vector 202"
          d="M42.3211 26.1622C42.3211 30.6696 42.3211 37.8136 42.3211 42.3211M42.3211 42.3211H26.1621M42.3211 42.3211L19.2368 19.2369"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7970_4223">
          <rect width="62" height="62" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

export default NewPriceIconLarge;
